<template>
  <header class="header" :data-position="position">
    <nav class="navbar navbar-expand-lg" :class="[position == 'body' ? 'navbar-light' : 'navbar-dark']">
      <div class="container">
        <a class="navbar-brand" href="#">
          <img :src="'/images/logo/logo' + (position == 'body' ? '' : '-white') + '.svg'" class="logo" alt="Logo" />
        </a>
        <button class="navbar-toggler" data-bs-toggle="collapse" data-bs-target="#navbar" ref="toggler">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="navbar-collapse collapse" id="navbar" ref="collapsible">
          <ul class="navbar-nav ms-auto">
            <li class="nav-item">
              <a href="#">
                {{ t('Home') }}
              </a>
            </li>
            <li class="nav-item">
              <a href="#strength">
                {{ t('Why Choose Us?') }}
              </a>
            </li>
            <li class="nav-item">
              <a href="#pricing">
                {{ t('Subscription Plans') }}
              </a>
            </li>
            <li class="nav-item">
              <a href="#feature">
                {{ t('Why Pay Monthly?') }}
              </a>
            </li>
            <li class="nav-item">
              <a href="#portfolio">
                {{ t('Portfolios') }}
              </a>
            </li>
            <li class="nav-item">
              <a href="#cta">
                {{ t('Get In Touch') }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </header>
</template>

<style lang="scss" scoped>
@import '~/_variables.scss';

.header {
  color: #fff;
  left: 0;
  padding: 1rem 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1010;

  .logo {
    height: 40px;
  }

  .navbar-nav {
    .nav-item {
      counter-increment: number;
      margin: 1rem 1rem 0;
      position: relative;

      &::before {
        content: '0' counter(number);
        font-size: 0.75em;
        opacity: 0.75;
        position: absolute;
        right: 0;
        top: -1rem;
      }

      a {
        color: #fff;
        font-family: 'Rubik', sans-serif;
        font-weight: 500;
      }
    }
  }

  &[data-position='body'] {
    backdrop-filter: blur(2.5rem);
    background: linear-gradient(135deg, rgb(255 255 255 / 95%) 10%, rgb(255 255 255 / 75%) 65%, rgb(255 255 255 / 95%) 100%);
    box-shadow: 0 0 1rem 0 rgb(0 0 0 / 5%);
    color: #333;
    position: fixed;
    top: 0;

    .navbar-nav {
      .nav-item {
        a {
          color: #333;
        }
      }
    }
  }

  @media (max-width: 991.98px) {
    backdrop-filter: blur(0.5rem);
    background: rgba(34, 34, 34, 0.9);
    box-shadow: 0 0 1rem 0 rgb(0 0 0 / 5%);

    .navbar-nav {
      padding-top: 1rem;

      .nav-item {
        &::before {
          top: 0;
        }
      }
    }
  }
}
</style>

<script>
import { useI18n } from 'vue-i18n';

export default {
  data() {
    return {
      position: 'top'
    };
  },

  methods: {
    handleScroll: _.debounce(function () {
      this.position = window.scrollY < 100 ? 'top' : 'body';
    }, 50)
  },

  created() {
    window.addEventListener('scroll', this.handleScroll);
  },

  mounted() {
    this.handleScroll();
  },

  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  setup() {
    const { t } = useI18n({
      messages: {
        'en-MY': {
          'Get In Touch': 'Get In Touch',
          'Subscription Plans': 'Subscription Plans',
          'Why Choose Us?': 'Why Choose Us?',
          'Why Pay Monthly?': 'Why Pay Monthly?',
          Home: 'Home',
          Portfolios: 'Portfolios'
        },
        'zh-MY': {
          'Get In Touch': '联系我们',
          'Subscription Plans': '订阅配套',
          'Why Choose Us?': '为何选择我们？',
          'Why Pay Monthly?': '为何按月支付？',
          Home: '网站首页',
          Portfolios: '作品展示'
        },
        'ms-MY': {
          'Get In Touch': 'Hubungi Kami',
          'Subscription Plans': 'Pelan Langganan',
          'Why Choose Us?': 'Kenapa Pilih Kami?',
          'Why Pay Monthly?': 'Kenapa Bayar Bulanan?',
          Home: 'Laman Utama',
          Portfolios: 'Portfolio'
        }
      }
    });

    return { t };
  }
};
</script>
